<template>
  <div class="edit-row">
    <div data-testid="unplanned-leave-edit-from">
      <label for="From">From</label>
      <AlDatePicker
        :modelValue="month"
        v-model="startDate"
        name="From"
        :min="minDate"
        :max="endDate || maxDate"
      />
    </div>

    <div data-testid="unplanned-leave-edit-to">
      <label for="To">To</label>
      <AlDatePicker
        :modelValue="maxDate"
        v-model="endDate"
        name="To"
        :min="startDate || minDate"
        :max="maxDate"
      />
    </div>
    <div data-testid="unplanned-leave-edit-percentage">
      <label>Percentage</label>
      <Decimal
        v-model="percentage"
        append="%"
        :min="0"
        :max="100"
        :step="0.1"
        :decimals="1"
      />
    </div>
    <div class="edit-actions">
      <AlButton
        @click="save"
        id="unplanned-leave-edit-save-row"
        data-testid="save-row"
        ><i class="far fa-check" @click="save"
      /></AlButton>
      <AlButton
        @click="cancel"
        variant="secondary"
        id="unplanned-leave-edit-cancel-row"
        data-testid="delete-row"
        ><i class="far fa-times"
      /></AlButton>
    </div>
  </div>
</template>

<script>
import {
  AlDatePicker,
  Al2Button as AlButton,
} from "@playvox/almendra-components";
import { Decimal } from "@agyletime/wfm-vue-common";
import {
  format,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export default {
  name: "EditUnplannedLeaveRow",
  components: {
    AlDatePicker,
    AlButton,
    Decimal,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    leave: {
      type: Object,
      required: true,
    },
    month: {
      type: String,
      required: true,
    },
  },
  data() {
    let startDate = utcToZonedTime(this.month);
    let endDate = endOfMonth(utcToZonedTime(this.month));

    if (this.leave?.startDate) {
      startDate = utcToZonedTime(this.leave.startDate, "UTC");
    }

    if (this.leave?.endDate) {
      endDate = utcToZonedTime(this.leave.endDate, "UTC");
    }

    return {
      startDate: format(startDate, "yyyy-MM-dd"),
      endDate: format(endDate, "yyyy-MM-dd"),
      percentage: this.leave?.percentage || 0,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      const result = {
        startDate: zonedTimeToUtc(
          startOfDay(utcToZonedTime(new Date(this.startDate), "UTC")),
          "UTC"
        ),
        endDate: zonedTimeToUtc(
          endOfDay(utcToZonedTime(new Date(this.endDate), "UTC")),
          "UTC"
        ),
        percentage: this.percentage,
      };
      this.$emit("save", result);
    },
  },
  computed: {
    minDate() {
      const date = utcToZonedTime(this.month);
      return format(startOfMonth(date), "yyyy-MM-dd");
    },
    maxDate() {
      const date = utcToZonedTime(this.month);
      return format(endOfMonth(date), "yyyy-MM-dd");
    },
    defaultDate() {
      const date = utcToZonedTime(this.month);
      return format(date, "yyyy-MM-dd");
    },
  },
};
</script>

<style lang="scss"></style>
